import {
  useCallback
} from "react";
import { useTexts } from "./useTexts.js";
function useTextfieldProps(dispatch, state, props) {
  const { error: propsError, slotProps, format, label, localeText, helperText, disabled } = props;
  const { displayValue, error: stateError } = state;
  const texts = useTexts(localeText);
  const onChange = useCallback(
    (event) => {
      dispatch({ type: "textfield:change", event });
    },
    // dispatch is a stable function, putting as a deps has no effect
    [dispatch]
  );
  const onBlur = useCallback(
    (event) => {
      dispatch({ type: "textfield:blur", event });
    },
    // dispatch is a stable function, putting as a deps has no effect
    [dispatch]
  );
  const onKeyDown = useCallback(
    (event) => {
      dispatch({ type: "textfield:keydown", event });
    },
    // dispatch is a stable function, putting as a deps has no effect
    [dispatch]
  );
  const onClick = useCallback(
    (event) => {
      dispatch({ type: "textfield:click", event });
    },
    // dispatch is a stable function, putting as a deps has no effect
    [dispatch]
  );
  return {
    ...slotProps?.textfield,
    label,
    placeholder: computePlaceholder(format),
    onChange,
    onKeyDown,
    onClick,
    onBlur,
    fullWidth: true,
    value: displayValue,
    error: stateError !== null || propsError,
    helperText: stateError ? texts.error.invalidFormat : helperText,
    disabled
  };
}
function computePlaceholder(format) {
  switch (format) {
    case "hh":
    case "mm":
    case "ss":
      return "00";
    case "hh:mm":
      return "00:00";
    case "hh:mm:ss":
      return "00:00:00";
  }
}
export {
  useTextfieldProps
};
//# sourceMappingURL=useTextfieldProps.js.map
